import React from "react";
import { find } from "lodash";
import { getFacetName } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { Button, Fieldset } from "@ui-kit/form";
import { Label } from "@ui-kit/form";
import { useFacetsFromContext } from "@radarly/core/facets/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import {
  isDateMetricCard,
  isDateMetricsCard,
  isDemographicCard,
} from "@radarly/models/cards/is";
import { CardTerm } from "@radarly/models/cards/term";
import { FullFacet } from "@radarly/models/facets";

interface IProps {
  card: Card;
  term: CardTerm;
  title: string;
  openPanel: () => void;
}

function getTermLabel(
  card: Card,
  facet: FullFacet,
  term: CardTerm,
  locale: Locale
) {
  return isDemographicCard(card)
    ? tr(locale, `CUSTOM_PAGES::EDITOR::DEMOGRAPHICS`)
    : isDateMetricCard(card) || isDateMetricsCard(card)
    ? tr(locale, `CUSTOM_PAGES::EDITOR::GLOBAL_VOLUME_AND_KPIS`)
    : facet
    ? facet.label
    : getFacetName(locale, term);
}

export default function SharedPanelsCardEditionSidebarSharedTerm({
  card,
  openPanel,
  term,
  title,
}: IProps) {
  const facets = useFacetsFromContext();
  const locale = useCurrentUserLocale();
  const facet = find(facets, { id: term });
  return (
    <Fieldset>
      <Label>{title}</Label>
      <Button onClick={openPanel} dropdownLookalike>
        {getTermLabel(card, facet, term, locale)}
      </Button>
    </Fieldset>
  );
}
